export const SETUP_EMAIL_PATH = '/setup/email';
export const LOGIN_PATH = '/login';
export const DASHBOARD_PATH = '/dashboard';
export const TASKS_PATH = '/tasks';

export const HOW_ARE_YOU_FEELING_PATH = '/how-are-you-feeling';
export const ABOUT_YOUR_SURGERY_PATH = '/surgery-info';
export const MEDICAL_CONSISTENCY_PATH = '/medical-consistency';

export const ROUTES = {
  PROFILE: '/profile',
} as const;

export const PROFILE_ROUTES = {
  PAYMENT_HISTORY: '/payment-history',
  PAYMENT_DETAILS: '/payment-details',
} as const;
